import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector} from "react-redux";
import {perModuleSelectionChanged} from "../../store/product/productSelectionsSlice";
import {sidePerModuleSelectionChanged} from "../../store/product/patternSelectionsSlice";
import {elementModuleSelectionsChanged} from "../../store/product/productElementsSlice";

const RowConfigSelect = (props) => {
    const dispatch = useDispatch();
    const selections = useSelector(state => state.productDataReducer.attribute_selections);
    const sideSelections = useSelector(state => state.productDataReducer.side_attribute_selections);

    //element selections go here ??
    const disabledFields = useSelector(state => state.disabledFieldsReducer.disabledFields);
    const disabledModules = useSelector(state => state.disabledFieldsReducer.disabledModules);
    const disabledSideFields = useSelector(state => state.disabledFieldsReducer.sideDisabledFields);
    const disabledPatternModules = useSelector(state => state.disabledFieldsReducer.sideModuleDisabledFields);
    const errorFields = useSelector(state => state.configuratorStateReducer.errorFields);
    const isPattern = useSelector(state => state.configuratorStateReducer.isPattern);
    const side = props.side;

    const disabled = () => {

        if(props.module.selections.includes(props.data.module_catalog_key)){
            // selected ones should not be disabled.
            return false
        }

        // disable error field ones (specifically for modules)
        if(errorFields.includes(props.data.id.toString())){
            return true;
        }

        // here we check module specific exceptions
        const matchingModule = getModuleFromDisabledModules()
        if(matchingModule){
            if(matchingModule.disabledSelections.includes(props.data.module_catalog_key)){
                return true
            } else if(isPattern){
                const disabledSides = disabledSideFields.find(dsf => Object.entries(dsf)[0][0] == side);
                const moduleAttribute = disabledSides[side].find(ds => ds.id == props.data.id);
                if(moduleAttribute.disabledSelections.includes(props.data.module_catalog_key)){
                    return true;
                }
            }
        }
        const currentSelection = getCurrentSelection();
        let valueToCheck
        // since were basing this on attribute selections, we need to add one more to the current value
        // or it will only check if it shouldve have disabled prior to selecting.
        if(currentSelection && currentSelection.selection) {
            valueToCheck = currentSelection.selection[0] + (parseInt(currentSelection.selection[1]) + 1);
        } else {
            valueToCheck = props.data.module_catalog_key + 1;
        }
        const selected = props.module.selection == props.data.module_catalog_key;
        if(currentSelection && !selected){
            const matchingField = disabledFields.find(df => df.id == props.data.id);
            // handle cases where a general selection is disabled (A,B,H)
            if(matchingField && matchingField.disabledSelections.includes(props.data.module_catalog_key)){
                return true;
            }
            return matchingField ? matchingField.disabledSelections.includes(valueToCheck) : false;
        }

        return false;
    }

    const getCurrentSelection = () => {
        if(isPattern){
            return sideSelections[side] ? sideSelections[side].product_attributes.find(sel => sel.id == props.data.id): null;
        } else {
            return selections.find(sel => sel.id == props.data.id);
        }
    }

    const getModuleFromDisabledModules = () => {
        if(isPattern){
            return disabledPatternModules[side] ? disabledPatternModules[side].find(mod => mod.id == props.module.module_id): null;
        } else {
            return disabledModules.find(mod => mod.id == props.module.module_id);
        }
    }

    const handleDisabledClick = (e) => {
        const field = disabledFields.find(df => df.id == props.data.id);
        let message = field.messages.filter(m => m != "");
        if(message.length == 0){
            // if no message, try looking in disabledModules
            const disabledModule = getModuleFromDisabledModules();
            if(disabledModule){
                message = disabledModule.messages.filter(m => m != "");
            }
        }
        props.setMessage(message ? message : []);
    }

    const handlePatternDisabledClick = (e) => {
        const field = disabledSideFields.find(si => Object.keys(si) == side)[side].find(df => df.id == props.data.id)
        let message = field.messages.filter(m => m != "");
        if(message.length == 0){
            // if no message, try looking in disabledModules
            const disabledModule = getModuleFromDisabledModules();
            if(disabledModule){
                message = disabledModule.messages.filter(m => m != "");
            }
        }
        props.setMessage(message ? message : []);

    }

    const handleChange = (e, isDisabled) => {
        if(isDisabled){
            e.preventDefault();
            return;
        }
        let value = e.target.value
        if(!e.target.checked) {
            value = "";
        }
        if(isPattern){
            dispatch(sidePerModuleSelectionChanged(side, props.module.module_id, value, props.data.module_catalog_key, props.data))
        }else if (props.isElement){
            dispatch(elementModuleSelectionsChanged(props.elementId, value, props.data.module_catalog_key, props.module.module_id))
        } else {
            dispatch(perModuleSelectionChanged(props.module.module_id, value, props.data.module_catalog_key, props.data))
        }
    }

    const handleClick = (e, isDisabled) => {
        if(isDisabled) {
            e.preventDefault()
            const mouseX = e.pageX;
            props.setLeft(mouseX);

            if(isPattern){
                handlePatternDisabledClick(e);
            } else {
                handleDisabledClick(e);
            }

        }
    }


    if(!props.data){
        return null;
    }
    const disabledStyle = {
        opacity: 0.3,
        margin: 'auto'
    }

    const shouldDisable = disabled()
    const key = 'group-' + props.id + '-' + shouldDisable;
    const classes = shouldDisable ? "disabled":"enabled";
    return (
        <label className={classes + " label_radio "} style={{display: 'grid', margin: '0 auto', float: 'none'}}   key={'t'} >
            <input type="checkbox"  key={key} value={props.data.module_catalog_key} name={key}
                   onClick={(e) => handleClick(e, shouldDisable)}
                   onChange={(e) => handleChange(e, shouldDisable)}
                   checked={props.module.selections.includes(props.data.module_catalog_key)}
                   style={shouldDisable ? disabledStyle : {margin: 'auto'}}
                   onBlur={props.onBlur}
            ></input>
            <b className="checkbox"></b>
        </label>
    )

};

RowConfigSelect.propTypes = {
    data: PropTypes.object.isRequired,
    module: PropTypes.object.isRequired
};

export default RowConfigSelect;